module.exports = __webpack_public_path__ + "static/gif-transparentBG-e3052eec907e9ab0efb6bc7eff181eef.gif";